// @ts-nocheck
import React from 'react';

import Icon from 'dpl/common/components/Icon';
import Drawer, {
  DrawerItem,
  DrawerItemTitle,
  DrawerItemContent
} from 'dpl/common/components/Drawer';

interface SelectPaymentTypeLearnMoreDrawerProps {
  icon: string;
  title: string;
  subtitle: string;
  content: string;
  helpTitle?: string | null;
  helpIssues?: string[];
  learnMoreLink?: string | null;
}

export default function SelectPaymentTypeLearnMoreDrawer({
  icon,
  title,
  subtitle,
  content,
  helpTitle = null,
  helpIssues = [],
  learnMoreLink = null
}: SelectPaymentTypeLearnMoreDrawerProps) {
  return (
    <div className="SelectPaymentTypeLearnMoreDrawer">
      <Drawer>
        <div className="ba br3 b--lightest-gray">
          <DrawerItem itemKey={helpTitle} className="">
            <div className="pv4 ph6">
              <div className="flex align-items-center mb3">
                <div className="br-100 bg-gray-200 padding-h-6 padding-v-6">
                  <Icon
                    name={icon}
                    height="20px"
                    width="20px"
                    className="blue-500"
                  />
                </div>
                <h5 className="font-18 md:font-20 ml2 ml3-md lh-normal">
                  {title}
                </h5>
              </div>
              <p className="fw-medium font-14 md:font-16 mb2">{subtitle}</p>
              <p className="font-14 md:font-16">{content}</p>
            </div>
            {helpTitle && (
              <div className="ph6 bt b--lightest-gray">
                <DrawerItemTitle className="pv3 pv4-md">
                  <p className="font-14 md:font-16 fw-medium">{helpTitle}</p>
                </DrawerItemTitle>
                <DrawerItemContent>
                  <ul className="SelectPaymentTypeLearnMoreDrawer ml3 ph2">
                    {helpIssues.map(issue => (
                      <li
                        className="font-14 md:font-16 list--disc-outside mb2"
                        key={issue}
                      >
                        {issue}
                      </li>
                    ))}
                  </ul>
                  {learnMoreLink && (
                    <a
                      className="font-14 md:font-16 stone-700 underline"
                      href={learnMoreLink}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Learn more
                    </a>
                  )}
                </DrawerItemContent>
              </div>
            )}
          </DrawerItem>
        </div>
      </Drawer>
    </div>
  );
}
